export default __webpack_public_path__ + "static/media/third.37b04862.gif";